/**
 * mwApp.devices module <br>
 * Work with streams: show/add/edit/remove
 *
 * @namespace mwApp/streams
 */

import StreamsCtrl from './streams.controller'
import TranscodingStatusCtrl from './transcodingStatus.controller'
import streamsConfig from './streams.config'
import AddURLPolicyCtrl from './addURLPolicy.controller'
import URLPoliciesCtrl from './urlPolicies.controller'
import { urlRule } from './urlRule.directive'
import SetrixServerSettingsCtrl from '../packages/setrixServerSettings.controller'

export default
angular.module('mwApp.streams', [])
  .config(streamsConfig)
  .directive('urlRule', urlRule)
  .controller('StreamsCtrl', StreamsCtrl)
  .controller('TranscodingStatusCtrl', TranscodingStatusCtrl)
  .controller('AddURLPolicyCtrl', AddURLPolicyCtrl)
  .controller('URLPoliciesCtrl', URLPoliciesCtrl)
  .controller('SetrixServerSettingsCtrl', SetrixServerSettingsCtrl)
